import { useGetCreativesQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

interface ShowcaseMotivationCreativesArgs {
  motivationId: string
  /** Scope creatives to a single game (game-page detail view). */
  gameId?: string | null
}

/**
 * The creatives that carry a motivation, best performing first, for the
 * Showcase detail views. Scoped to a game when `gameId` is given, otherwise to
 * the dashboard genre filter.
 */
export const useShowcaseMotivationCreatives = ({ motivationId, gameId }: ShowcaseMotivationCreativesArgs) => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetCreativesQuery({
    carriesMotivationId: motivationId,
    sort: 'installShare',
    gameId: gameId ?? undefined,
    genreId: gameId ? undefined : genreFilter ?? undefined,
    networkId: networkId ?? undefined,
    month: month ?? undefined,
  })
  return { data, isLoading: isFetching, isError, refetch }
}
